import { render, staticRenderFns } from "./Liquid.vue?vue&type=template&id=36e7a13c&scoped=true"
import script from "./Liquid.vue?vue&type=script&lang=js"
export * from "./Liquid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e7a13c",
  null
  
)

export default component.exports